// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p5-6";
export var imgContainer = "_p5-3";
export var menuIcon = "_p5-5";
export var pillWrapper = "_p5-2";
export var pillsContainer = "_p5-1";
export var subscriptionCard = "_p5-0";
export var subscriptionLogo = "_p5-4";